import { render, staticRenderFns } from "./LeaderboardAd.vue?vue&type=template&id=c9cdb35e&"
import script from "./LeaderboardAd.vue?vue&type=script&lang=js&"
export * from "./LeaderboardAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports